import React from 'react';
import './HeaderTop.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faYoutube, faTelegramPlane, faLinkedinIn, faTiktok } from '@fortawesome/free-brands-svg-icons';

function HeaderTop() {
  return (
    <div className="header-top">
      <div className="auto-container">
        <div className="inner-container">
          <div className="left-column">
            <div className="text">
              Elevate Your Potential: Discover, Innovate, Transform <span >@</span>Admas University
            </div>
			   <div className="blink-section">
            <span className="blink-text texth">🎓 Class of 2025 – Graduation Ceremony on July 27</span>
          </div>
          </div>
          <div className='text' style={{ color: 'white', marginLeft: '170px' }}>
            <span className="flaticon-phone "></span>
            <a href="tel:0115508808"  style={{ color: 'white' }}> 0115-50-88-08/10</a>
          </div>
          <div className="left-column"  style={{ color: 'white', marginLeft: '155px' }}>
            <a
              href="https://web.facebook.com/AdmasUni?_rdc=1&_rdr#"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Visit Admas University on Facebook"
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a
              href="https://youtu.be/LX27kp0ykDs"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon youtube"
              aria-label="Watch Admas University on YouTube"
            >
              <FontAwesomeIcon icon={faYoutube} />
            </a>
            <a
              href="https://t.me/AdmasAA"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon  "
              aria-label="Join Admas University on Telegram"
            >
              <FontAwesomeIcon icon={faTelegramPlane} />
            </a>
            <a
              href="https://www.linkedin.com/company/admas-universityeth/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Visit Admas University on LinkedIn"
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
            <a
              href="https://www.tiktok.com/@admasuniversityofficial"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Visit Admas University on TikTok"
            >
              <FontAwesomeIcon icon={faTiktok} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeaderTop;